const IconWrapper = ({ className, icon: Icon, styles }) => {
  return (
    <div className={className}>
      <Icon styles={styles} />
    </div>
  )
}

export default IconWrapper
